/**
 * URL mapping file
 */
const URLS = {
    /** Track & Trace  */ 
    FETCH_TABLE_DATA: "/shipments/search",
    FETCH_TMS_REASON_META: "/shipment/tms-reason-metadata",
    SAVE_STOPS_DATA: "/shipment/stops",
    RETRIGGER_EVENT: "/shipments/retrigger",
    FETCH_COMMENTS: "/users/comment/search",
    ADD_COMMENT: "/users/comment",

    /** Carrier Performance  */ 
    FETCH_LOCATION_METADATA: "/archive/shipments/origin-locations",
    FETCH_CARRIER_SERVICE_METADATA: "/archive/shipments/carriers",
    // FETCH_SUMMARY: "archive/shipments/summary",
    /** On Time */
    ON_TIME_PERFORMANCE: "archive/shipments/summary/ontime-performance",
    FETCH_TABLE_DATA_ON_TIME_PERFORMANCE: "/archive/shipments/search",
    /** First Tender Compliance */
    FIRST_TENDER: "archive/shipments/summary/first-tender-compliance",   
    FETCH_TABLE_DATA_FIRST_TENDER: "/archive/shipments/tender-response/search",
    /** Lane Award Compliance */
    LANE_AWARD_COMPLIANCE: "/archive/summary/lane-award-compliance",
    FETCH_TABLE_DATA_LANE_AWARD: "/archive/lane-award-compliance/search", 
    /** Carrier Event Response */  
    CARRIER_EVENT_RESPONSE: "archive/shipments/summary/carrier-event-response-efficiency",
    FETCH_TABLE_DATA_CARRIER_EVENT_RESPONSE_PICK: "/archive/shipments/carrier-event-response-efficiency/pickStops/search",
    FETCH_TABLE_DATA_CARRIER_EVENT_RESPONSE_DROP: "/archive/shipments/carrier-event-response-efficiency/dropStops/search",
    /** FourKites Tracking Consistency */
    FOURKITES_TRACKING: "archive/shipments/summary/fourkites-tracking-consistency",
    /** Billing Accuracy */
    BILLING_ACCURACY: "archive/shipments/summary/billing-accuracy",
    /** Trailer Pool Visualization */
    TRAILER_POOL_COMPLIANCE: "/archive/summary/trailer-pool-compliance",
    FETCH_TABLE_DATA_TRAILER_POOL: "/archive/trailer-pool-compliance/search",


    //DRMT API URL
    // COUPA_FILE_UPLOAD : "http://localhost:8080/tmt/bid/upload-bid-file",
    // DRM_BID_TABLE_DETAILS : "http://localhost:8080/tmt/bid/bid-details",
    // DRM_DAILY_TABLE_DETAILS : "http://localhost:8080/tmt/daily-maintenance/details",
    // DRM_COUNTRY_LIST : "http://localhost:8080/tmt/master-data/countries",
    // DRM_DIVISION_LIST : "http://localhost:8080/tmt/master-data/divisions",
    // DRM_CITY_LIST : "http://localhost:8080/tmt/master-data/all-cities",
    // DRM_ZONE_LIST : "http://localhost:8080/tmt/master-data/zones",
    // DRM_STATE_LIST : "http://localhost:8080/tmt/master-data/states",
    // DRM_CARRIER_LIST : "http://localhost:8080/tmt/master-data/carriers",
    // DRM_SERVICE_LIST : "http://localhost:8080/tmt/master-data/service-details",
    // DRM_TARIFF_DATA: "http://localhost:8080/tmt/master-data/tariff-data-by-chargcode-service",
    //DRM_ZONE_SHORT_DESC_LIST : "http://localhost:8080/tmt/master-data/zone-by-short-desc",
    //DRM_ZONE_LONG_DESC_LIST : "http://localhost:8080/tmt/master-data/zone-by-desc",
    // DRM_TRANSPORT_LIST : "http://localhost:8080/tmt/master-data/transport",
    // DRM_EQUIPMENT_LIST : "http://localhost:8080/tmt/master-data/equipment-types",
    // DRM_CHARGES_LIST : "http://localhost:8080/tmt/master-data/charges",
    // DRM_BID_TABLE_DATA_UPDATE : "http://localhost:8080/tmt/bid/update",
    // DRM_DAILY_TABLE_DATA_CREATE : "http://localhost:8080/tmt/bid/update",
    // DRM_MAKE_TO_PROCESS: 'http://localhost:8080/tmt/bid/mark-to-process',
    // DRM_DELETE_DETAILS: 'http://localhost:8080/tmt/bid/delete',
    // //DRM_DAILY_UPDATE: 'http://localhost:8080/tmt/daily-maintenance/update',
    // DRM_DAILY_CREATE_UPDATE: 'http://localhost:8080/tmt/daily-maintenance/create-or-update',
    // DRM_CUSTOM_COLUMN_FETCH: 'http://localhost:8080/tmt/universal/customer-view/get-details',
    // DRM_CUSTOM_COLUMN_CREATE_UPDATE: 'http://localhost:8080/tmt/universal/customer-view/create-or-update',
    // DRM_CUSTOM_COLUMN_DELETE: 'http://localhost:8080/tmt/universal/customer-view/delete',
    // DRM_CEA_PROFILE_ZIP_DOWNLOAD: 'http://localhost:8080/tmt/cea-profile/download',
    // DRM_CHANGE_LOG_TABLE_DETAILS: 'http://localhost:8080/tmt/universal/txn-history/details',
    // DRM_DAILY_RECORD_CANCEL: 'http://localhost:8080/tmt/daily-maintenance/cancel',
    //DRM_REPORT_DETAILS: 'http://localhost:8080/tmt/report/get-details',
    //DRM_COUPA_FILE_DELETE_DETAILS: 'http://localhost:8080/tmt/bid/coupa-files',

    COUPA_FILE_UPLOAD : "/tmt/bid/upload-bid-file",
    DRM_BID_TABLE_DETAILS : "/tmt/bid/bid-details",
    DRM_DAILY_TABLE_DETAILS : "/tmt/daily-maintenance/details",
    DRM_COUNTRY_LIST : "/tmt/master-data/countries",
    DRM_DIVISION_LIST : "/tmt/master-data/divisions",
    DRM_CITY_LIST : "/tmt/master-data/all-cities",
    DRM_ZONE_LIST : "/tmt/master-data/zones",
    DRM_STATE_LIST : "/tmt/master-data/states",
    DRM_CARRIER_LIST : "/tmt/master-data/carriers",
    DRM_SERVICE_LIST : "/tmt/master-data/service-details",
    DRM_TARIFF_DATA: "/tmt/master-data/tariff-data-by-chargcode-service",
    DRM_ZONE_SHORT_DESC_LIST : "/tmt/master-data/zone-by-short-desc",
    DRM_ZONE_LONG_DESC_LIST : "/tmt/master-data/zone-by-desc",
    DRM_BID_TABLE_DATA_UPDATE : "/tmt/bid/update",
    DRM_DAILY_TABLE_DATA_CREATE : "/tmt/bid/update",
    DRM_MAKE_TO_PROCESS: '/tmt/bid/mark-to-process',
    DRM_DELETE_DETAILS: '/tmt/bid/delete',
    DRM_CHARGES_LIST: '/tmt/master-data/charges',
    DRM_EQUIPMENT_LIST: '/tmt/master-data/equipment-types',
    DRM_TRANSPORT_LIST: '/tmt/master-data/transport',
    // DRM_DAILY_UPDATE: '/tmt/daily-maintenance/update',//no need
    DRM_DAILY_CREATE_UPDATE: '/tmt/daily-maintenance/create-or-update',
    DRM_CUSTOM_COLUMN_FETCH: '/tmt/universal/customer-view/get-details',
    DRM_CUSTOM_COLUMN_CREATE_UPDATE: '/tmt/universal/customer-view/create-or-update',
    DRM_CUSTOM_COLUMN_DELETE: '/tmt/universal/customer-view/delete',
    DRM_CEA_PROFILE_ZIP_DOWNLOAD: '/tmt/cea-profile/download',
    DRM_CEA_PROFILE_LIST: '/tmt/cea-profile/list',
    DRM_CEA_PROFILE_DOWNLOAD_FILES: '/tmt/cea-profile/download-files',
    DRM_CHANGE_LOG_TABLE_DETAILS: '/tmt/universal/txn-history/details',
    DRM_DAILY_RECORD_CANCEL: '/tmt/daily-maintenance/cancel',
    DRM_REPORT_DETAILS: '/tmt/report/get-details',
    DRM_COUPA_FILE_DELETE_DETAILS: '/tmt/bid/coupa-files',
    DRM_DELETE_BY_COUPA_ID: '/tmt/bid/delete-by-coupa-id',
    DRM_UPDATE_BY_COUPA_ID: '/tmt/bid/update-by-coupa-id',
    DRM_INACTIVE_CEA_DETAILS: '/tmt/cea-profile/inactive-cea-details',
    DRM_MARK_FOR_EXPIRE: '/tmt/bid/mark-for-expire',
    DRM_EXPIRE_BY_COUPA_ID: '/tmt/bid/mark-rate-expire-by-coupa-id',
    DRM_TARIFF_EQUIP_TYPE_MAPPING: '/tmt/master-data/tariff-equipment-mapping',
                                    
}

export default URLS;